import axios from "axios";
import { useState } from "react";
import { Alert, Modal } from "react-bootstrap";
import AlertBox from "~/shared/AlertBox";
import DataTable from "~/shared/DataTable";
import ControlledForm from "~/shared/form/ControlledForm";
import FormButton from "~/shared/form/FormButton";
import FormResponse from "~/shared/form/FormResponse";
import TextInput from "~/shared/form/TextInput";
import useAxiosData from "~/shared/use-axios-data";

export default function ManageAdmins() {
    const [showModal, setShowModal] = useState(false);
    const [admins, status, setAdmins] = useAxiosData(() => axios.get("admin/admin/get"), []);

    function getAdminActions(admin) {
        if (admin.accountStatus === "Invite Sent") {
            return <DataTable.Action onClick={() => deleteAdmin(admin._id)}>Delete Invite</DataTable.Action>;
        }

        return "None";
    }

    async function deleteAdmin(id) {
        await axios.post("admin/admin/delete", { id });
        setAdmins(admins => admins.filter(a => a._id !== id));
    }

    function onSuccess({ _id }, __, data) {
        setAdmins([...admins, { _id, email: data.inviteRecipient, accountStatus: "Invite Sent" }]);
    }

    return (
        <section>
            <DataTable data={admins} paginate loading={status === "loading"}>
                <DataTable.Column id="email" sortable>Email</DataTable.Column>
                <DataTable.Column id="accountStatus" sortable>Status</DataTable.Column>
                <DataTable.Column value={getAdminActions}>Actions</DataTable.Column>
                <DataTable.Message condition={status === "error"}>
                    <AlertBox type="error">An unknown error occurred. Please try again later.</AlertBox>
                </DataTable.Message>
                <DataTable.Message condition={admins.length === 0}>
                    <AlertBox type="info">No admin accounts found.</AlertBox>
                </DataTable.Message>
            </DataTable>

            <button className="large-button mt-3" onClick={() => setShowModal(true)} disabled={status !== "success"}>Invite Admin</button>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Invite Admin</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ maxWidth: "32rem" }}>
                        To invite a new admin, enter their email address. They will receive an email invite with instructions on how to set up their account.
                    </p>
                    <ControlledForm onSubmit={data => data.role = "ADMIN"} post="admin/invite-user" onSuccess={onSuccess} success="Successfully sent invitation email." resetOnSuccess>
                        <TextInput label="Email Address" id="inviteRecipient" preset="email" required />
                        <FormResponse />
                        <FormButton legacy submit className="mt-4">Send Invite</FormButton>
                    </ControlledForm>
                </Modal.Body>
            </Modal>
        </section>
    );
}